<template>
  <MainContent>
    <div v-if="activeCompany" :key="activeCompany._id">
      <WinbackView v-if="activeCompany._id !== 'ALL_COMPANIES'" />
      <NewAllCompaniesView v-else />
    </div>
  </MainContent>
</template>

<script>
import MainContent from '@/components/MainContent/MainContent'
import WinbackView from '@/components/Modules/Winback/WinbackView.vue'
import NewAllCompaniesView from '@/components/Modules/WinbackV2/NewAllCompaniesView'
import { trackEvent } from '@/lib/analytics'
import { createNamespacedHelpers } from 'vuex'

const CompanyModule = createNamespacedHelpers('company')

export default {
  name: 'WinbackPage',
  components: {
    MainContent,
    WinbackView,
    NewAllCompaniesView
  },
  mounted() {
    trackEvent(this.$intercom, 'Winback')
  },
  computed: {
    ...CompanyModule.mapGetters(['activeCompany'])
  },
  methods: {}
}
</script>

<style scoped lang="scss"></style>
